/* eslint import/no-webpack-loader-syntax: off */
import mapboxgl from "mapbox-gl"; // This is a dependency of react-map-gl even if you didn't explicitly install it
import Map, {
  Marker,
  NavigationControl,
  FullscreenControl,
  GeolocateControl,
} from "!react-map-gl";
import { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { isEmpty, isNull } from "lodash";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import CustomModal from "../../../utils/CustomModal/CustomModal";
import PaginationList from "./../../../utils/PaginationList/PaginationList";
import ItemInfo from "../../../utils/ItemInfo/ItemInfo";
import WalletAdminContext from "../../../context/Admin/WalletAdminContext/WalletAdminContext";
import { UserWallet } from "../WalletAdmin/WalletAdmin";
import {
  areYouSureMessage,
  toastErrorMessage,
} from "../../../utils/toastMessage/toastMessage";
import { userAdminContext } from "../../../context/Admin/UserAdminContext/UserAdminContext";
import MapMarkerIcon from "./../../../utils/MapMarkerIcon/MapMarkerIcon";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../../redux/actions/loadingActions/loadingActions";
import {
  createUserAddressService,
  editUserAddressService,
} from "../../../services/userServices";
import {
  initialViewState,
  mapBoxAccessToken,
  numberSeparate,
} from "../../../utils";

import "./../../../assets/css/mapbox-gl.css";
import Animations from "../../../utils/Animations";
import TooltipTitle from "../../../utils/TooltipTitle/TooltipTitle";

mapboxgl.workerClass =
  require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

const UserAdmin = ({ isNotPage = false }) => {
  const permission = useSelector((state) => state.permission);
  const appConfigs = useSelector((state) => state.appConfigs);
  const introductionItems = appConfigs?.INTRODUCTION_CHOICES_USER?.split("،");

  const {
    employers,
    users,
    user,
    addresses,
    id,
    app_type,
    setApp_type,
    app_version,
    setApp_version,
    sort_by,
    setSort_by,
    first_name,
    setFirst_name,
    last_name,
    setLast_name,
    mobile,
    setMobile,
    email,
    setEmail,
    introduction,
    setIntroduction,
    employer,
    setEmployer,
    search,
    setSearch,
    isShowModal,
    totalCount,
    pageNumber,
    setPageNumber,
    limit,
    setLimit,
    isShowDetailsModal,
    isShowAdvancedSearch,
    setIsShowAdvancedSearch,
    handleCloseDetailsModal,
    handleShowModal,
    handleCloseModal,
    handleShowDetailsModal,
    handleGetEmployers,
    handleGetUsers,
    handleGetUser,
    handleDeleteUser,
    handleCreateUser,
    handleEditUser,
    handleCreateUserEmployer,
    handleDeleteUserEmployer,
    handleGetAddresses,
  } = useContext(userAdminContext);

  useEffect(() => {
    if (!isNotPage) handleGetUsers();
  }, [pageNumber, limit, employer, app_type, sort_by]);

  useEffect(() => {
    handleGetEmployers();
  }, []);

  const app_types = appConfigs?.APP_TYPE_CHOICES?.split("،");

  const sortByOptions = [
    {
      label: "تاریخ ایجاد",
      options: [
        { title: "نزولی", value: "-created" },
        { title: "صعودی", value: "created" },
      ],
    },
    {
      label: "نام",
      options: [
        { title: "نزولی", value: "-first_name" },
        { title: "صعودی", value: "first_name" },
      ],
    },
    {
      label: "نام خانوادگی",
      options: [
        { title: "نزولی", value: "-last_name" },
        { title: "صعودی", value: "last_name" },
      ],
    },
    {
      label: "موبایل",
      options: [
        { title: "نزولی", value: "-mobile" },
        { title: "صعودی", value: "mobile" },
      ],
    },
  ];

  return (
    <>
      {!isNotPage && (
        <>
          <SiteTitle title="کاربران" />
          <Breadcrumbs
            navs={[
              { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
              { name: "کاربران", type: "a" },
            ]}
            title="لیست کاربران"
          />
        </>
      )}

      <CardLayout>
        {permission.users_create && (
          <div className="mb-2">
            <button
              onClick={() => setIsShowAdvancedSearch(!isShowAdvancedSearch)}
              className={`btn btn-${
                isShowAdvancedSearch ? "" : "outline-"
              }primary mr-2`}
            >
              جستجو پیشرفته
            </button>
            <button
              className="btn btn-success"
              onClick={() => handleShowModal()}
            >
              <i className="fa fa-plus mr-2" />
              افزودن
            </button>
          </div>
        )}

        <form onSubmit={handleGetUsers}>
          <div className="input-group mb-3">
            <div>
              <select
                className="form-control"
                id="employer"
                name="employer"
                value={employer}
                onChange={(e) => setEmployer(e.target.value)}
              >
                <option value="">سازمان: همه</option>
                {employers.map((_item) => (
                  <option key={_item.id} value={_item.id}>
                    {_item.name}
                  </option>
                ))}
              </select>
            </div>
            <input
              type="text"
              name="search"
              autoComplete="off"
              placeholder="جستجو ..."
              className="form-control"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <div className="input-group-append">
              <button type="submit" className="btn btn-primary">
                جستجو
              </button>
            </div>
          </div>
        </form>

        {isShowAdvancedSearch && (
          <Animations name="fadeIn">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <TooltipTitle title="نوع اپلیکیشن">
                  <select
                    className="form-control mb-3"
                    onChange={(e) => setApp_type(e.target.value)}
                    value={app_type}
                  >
                    <option value="" selected={"" === app_type}>
                      نوع اپلیکیشن: همه
                    </option>
                    {app_types?.map((item, index) => (
                      <option value={index} selected={index === app_type}>
                        {item}
                      </option>
                    ))}
                  </select>
                </TooltipTitle>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <TooltipTitle title="ورژن اپلیکیشن">
                  <input
                    placeholder="ورژن اپلیکیشن"
                    className="form-control mb-3"
                    value={app_version}
                    onChange={(e) => setApp_version(e.target.value)}
                  />
                </TooltipTitle>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <TooltipTitle title="مرتب سازی بر اساس">
                  <select
                    className="form-control"
                    value={sort_by}
                    onChange={(e) => setSort_by(e.target.value)}
                  >
                    {sortByOptions.map((_item, index) => (
                      <optgroup label={_item.label} key={index}>
                        {_item.options?.map((option) => (
                          <option
                            key={option.value}
                            selected={sort_by === option.value}
                            value={option.value}
                          >
                            {option.title}
                          </option>
                        ))}
                      </optgroup>
                    ))}
                  </select>
                </TooltipTitle>
              </div>
            </div>
          </Animations>
        )}

        {isEmpty(users) ? (
          <EmptyData />
        ) : (
          <>
            {!isNotPage && (
              <div className="d-flex justify-content-between align-items-center">
                <PaginationList
                  setPageNumber={setPageNumber}
                  pageCount={totalCount / limit}
                />
                <div>
                  <select
                    className="form-control mb-3"
                    onChange={(e) => setLimit(Number(e.target.value))}
                  >
                    <option value={10} selected={10 === limit}>
                      10
                    </option>
                    <option value={25} selected={25 === limit}>
                      25
                    </option>
                    <option value={50} selected={50 === limit}>
                      50
                    </option>
                    <option value={75} selected={75 === limit}>
                      75
                    </option>
                    <option value={100} selected={100 === limit}>
                      100
                    </option>
                  </select>
                </div>
              </div>
            )}
            <Table responsive hover borderless striped>
              <thead className="thead-dark">
                <tr>
                  <th>#</th>
                  <th>شناسه</th>
                  <th>نام</th>
                  <th>نام خانوادگی</th>
                  <th>موبایل</th>
                  <th>کل سفارشات</th>
                  <th>سفارشات فعال</th>
                  <th>نوع اپلیکیشن</th>
                  <th>ورژن اپلیکیشن</th>
                  <th className="text-center">
                    تعداد کل :
                    <span className="badge badge-primary font-weight-bold p-1">
                      {totalCount}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {users.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{_item.pk}</td>
                    <td>{_item.first_name}</td>
                    <td>{_item.last_name}</td>
                    <td>{_item.mobile}</td>
                    <td>{_item.total_count}</td>
                    <td>{_item.active_count}</td>
                    <td>
                      {_item.app_type ? app_types?.[_item?.app_type] : "-"}
                    </td>
                    <td>{_item.app_version ?? "-"}</td>
                    <td className="mw-25">
                      {/* <button
                        onClick={() =>
                          handleGetUser(_item.pk, handleShowDetailsModal)
                        }
                        className="btn btn-info mr-2"
                      >
                        جزئیات
                      </button> */}
                      <WalletAdminContext isUser>
                        <UserWallet data={_item} />
                      </WalletAdminContext>
                      {permission.users_update && (
                        <button
                          onClick={() =>
                            handleGetUser(_item.pk, handleShowModal)
                          }
                          className="btn btn-primary mr-2"
                        >
                          جزئیات و ویرایش
                        </button>
                      )}
                      {permission.users_destroy && (
                        <i
                          onClick={() =>
                            areYouSureMessage(
                              () => handleDeleteUser(_item.pk),
                              `آیا از حذف ${_item.first_name} ${_item.last_name} اطمینان دارید؟`
                            )
                          }
                          className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Create Modal */}
      <CustomModal
        title={`${id ? "ویرایش" : "افزودن"} کاربر`}
        show={isShowModal}
        onHide={handleCloseModal}
        size={id ? "lg" : "md"}
      >
        <form
          onSubmit={id ? handleEditUser : handleCreateUser}
          autoComplete="off"
        >
          {id && (
            <div className="container">
              <div className="row">
                <ItemInfo label="کد دعوت">
                  <p>{user.invite_id}</p>
                </ItemInfo>
                <ItemInfo label="نوع اپلیکیشن">
                  <p>{user.app_type ? app_types[user?.app_type] : "-"}</p>
                </ItemInfo>
                <ItemInfo label="ورژن اپلیکیشن">
                  <p>{user.app_version ?? "-"}</p>
                </ItemInfo>
                <ItemInfo label="کیف پول">
                  <span dir="ltr">
                    {numberSeparate(user.wallet?.current_balance)}
                  </span>{" "}
                  ریال
                </ItemInfo>
                <ItemInfo label="توضیحات">
                  <p>{user.description ?? "-"}</p>
                </ItemInfo>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-12 mb-2">
              <label htmlFor="first_name">نام</label>
              <input
                type="text"
                id="first_name"
                name="first_name"
                className="form-control"
                value={first_name}
                onChange={(e) => setFirst_name(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="last_name">نام خانوادگی</label>
              <input
                type="text"
                id="last_name"
                name="last_name"
                className="form-control"
                value={last_name}
                onChange={(e) => setLast_name(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="mobile">موبایل</label>
              <input
                type="number"
                id="mobile"
                name="mobile"
                className="form-control"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label htmlFor="email">پست الکترونیک</label>
              <input
                type="text"
                id="email"
                name="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="col-12 mb-2">
              <label>نحوه آشنایی</label>
              <select
                className="form-control"
                onChange={(e) => setIntroduction(e.target.value)}
                disabled={user.introduction >= 0 && !isNull(user?.introduction)}
                value={introduction}
              >
                <option value="" disabled hidden>
                  نحوه آشنایی کاربر را انتخاب کنید
                </option>
                {introductionItems?.map((_item, index) => (
                  <option key={index} value={index}>
                    {_item}
                  </option>
                ))}
              </select>
            </div>
            {!id && (
              <>
                <div className="col-12 mb-2">
                  <label className="mb-1">سازمان (اختیاری)</label>
                  <select
                    className="form-control"
                    id="organizationCode"
                    name="organizationCode"
                  >
                    <option value="" disabled hidden selected>
                      سازمان کاربر را انتخاب کنید
                    </option>
                    {employers.map((_item) => (
                      <option key={_item.id} value={_item.organization_code}>
                        {_item.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-12 mb-2">
                  <label htmlFor="employeeCode" className="mb-1">
                    کد پرسنلی (اختیاری)
                  </label>
                  <input
                    type="text"
                    className="form-control element_heigher"
                    id="employeeCode"
                    name="employeeCode"
                  />
                </div>
              </>
            )}
          </div>
          <button className="btn btn-primary btn-block" type="submit">
            <i className="fas fa-check mr-2" /> {id ? "ویرایش" : "افزودن"}
          </button>
        </form>
        {id && (
          <>
            <hr />
            {user?.employer ? (
              <>
                <p className="alert alert-info">
                  کاربر در سازمان{" "}
                  <span className="text-primary">{user.employer?.name}</span> با
                  کد پرسنلی{" "}
                  <span className="text-primary">
                    {user.employee?.employee_code}
                  </span>{" "}
                  با سمت{" "}
                  <span className="text-primary">{user.employee?.post}</span>{" "}
                  عضو هست
                </p>
                {permission.admin_user_employer_delete && (
                  <button
                    className="btn btn-danger"
                    onClick={() =>
                      areYouSureMessage(
                        handleDeleteUserEmployer,
                        `آیا از حذف سازمان ${user.employer?.name} مطمئنید؟`
                      )
                    }
                  >
                    حذف سازمان
                  </button>
                )}
              </>
            ) : (
              <>
                {permission.admin_user_employer_create && (
                  <form autoComplete="off" onSubmit={handleCreateUserEmployer}>
                    <div>
                      <label className="mb-1">سازمان</label>
                      <select
                        className="form-control"
                        id="organizationCode"
                        name="organizationCode"
                      >
                        <option value="" selected disabled hidden>
                          سازمان کاربر را انتخاب کنید
                        </option>
                        {employers.map((_item) => (
                          <option
                            key={_item.id}
                            value={_item.organization_code}
                          >
                            {_item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mt-2">
                      <label htmlFor="employeeCode" className="mb-1">
                        کد پرسنلی
                      </label>
                      <input
                        type="text"
                        className="form-control element_heigher"
                        id="employeeCode"
                        name="employeeCode"
                      />
                    </div>
                    <div className="mt-3 d-grid">
                      <button className="btn btn-primary">
                        اعمال کد سازمانی
                      </button>
                    </div>
                  </form>
                )}
              </>
            )}
            <hr />
            <p>
              <CreateNewAddressUser
                user={user}
                getAddresses={handleGetAddresses}
              />
            </p>
            {isEmpty(addresses) ? (
              <EmptyData />
            ) : (
              <div className="row">
                {addresses.map((address) => (
                  <div key={address.id} className="col-12 col-md-6 mb-3">
                    <div className="card">
                      <div className="card-header d-flex justify-content-between align-items-center">
                        <span>{address.title}</span>
                        <div>
                          <EditAddressUser
                            user={user}
                            oldAddress={address}
                            getAddresses={handleGetAddresses}
                          />
                        </div>
                      </div>
                      <div className="card-body">
                        <Map
                          initialViewState={{ ...initialViewState }}
                          style={{ width: "auto", height: "40vh" }}
                          latitude={address.latitude}
                          longitude={address.longitude}
                          mapboxAccessToken={mapBoxAccessToken}
                          mapStyle="mapbox://styles/mapbox/streets-v11"
                        >
                          <FullscreenControl position="top-right" />
                          <NavigationControl position="top-left" />

                          <Marker
                            latitude={address.latitude}
                            longitude={address.longitude}
                            anchor="bottom"
                          >
                            <MapMarkerIcon />
                          </Marker>
                        </Map>
                      </div>
                      <div className="card-footer">{address.address}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </>
        )}
      </CustomModal>
      {/* End Create Modal */}

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات کاربر"
        show={isShowDetailsModal}
        onHide={handleCloseDetailsModal}
        size="xl"
      >
        <div className="container">
          <div className="row">
            <ItemInfo label="شناسه">
              <p>{user.pk}</p>
            </ItemInfo>
            <ItemInfo label="نام">
              <p>{user.first_name}</p>
            </ItemInfo>
            <ItemInfo label="نام خانوادگی">
              <p>{user.last_name}</p>
            </ItemInfo>
            <ItemInfo label="موبایل">
              <p>{user.mobile}</p>
            </ItemInfo>
            <ItemInfo label="پست الکترونیک">
              <p>{user.email}</p>
            </ItemInfo>
            {user.introduction >= 0 && !isNull(user?.introduction) && (
              <ItemInfo label="نحوه آشنایی">
                <p>{introductionItems[user.introduction]}</p>
              </ItemInfo>
            )}
            <ItemInfo label="کد دعوت">
              <p>{user.invite_id}</p>
            </ItemInfo>
            <ItemInfo label="نوع اپلیکیشن">
              <p>{user.app_type ? app_types[user?.app_type] : "-"}</p>
            </ItemInfo>
            <ItemInfo label="ورژن اپلیکیشن">
              <p>{user.app_version ?? "-"}</p>
            </ItemInfo>
            <ItemInfo label="کیف پول">
              <span dir="ltr">
                {numberSeparate(user.wallet?.current_balance)}
              </span>{" "}
              ریال
            </ItemInfo>
            <ItemInfo label="توضیحات">
              <p>{user.description ?? "-"}</p>
            </ItemInfo>
            {!isEmpty(user.employer) && (
              <>
                <ItemInfo label="نام سازمان">
                  <p>{user.employer.name}</p>
                </ItemInfo>
                <ItemInfo label="کد سازمان">
                  <p>{user.employer.organization_code}</p>
                </ItemInfo>
              </>
            )}
            {!isEmpty(user.employee) && (
              <>
                <ItemInfo label="سمت پرسنل">
                  <p>{user.employee.post}</p>
                </ItemInfo>
                <ItemInfo label="کد پرسنلی">
                  <p>{user.employee.employee_code}</p>
                </ItemInfo>
              </>
            )}
          </div>
        </div>
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default UserAdmin;

// Create new address with user
export const CreateNewAddressUser = ({ getAddresses, user }) => {
  const dispatch = useDispatch();

  const [title, setTitle] = useState("");
  const [address, setAddress] = useState("");
  const [longitude, setLongitude] = useState("");
  const [latitude, setLatitude] = useState("");
  const [step, setStep] = useState(1);
  const [isShowModal, setIsShowModal] = useState(false);

  const handleShowModal = () => {
    setIsShowModal(true);
  };
  const handleCloseModal = () => {
    setIsShowModal(false);
    setTitle("");
    setAddress("");
    setLongitude("");
    setLatitude("");
    setStep(1);
  };

  // Handle Change Step Method
  const handleChangeStep = (type = "Next") => {
    if (type === "Prev") {
      setStep(1);
    } else {
      if (!longitude || !latitude)
        return toastErrorMessage("لطفا آدرس کاربر را به درستی انتخاب کنید");

      setStep(2);
    }
  };

  // Handle Create Address Method
  const handleCreateAddress = async (event) => {
    event.preventDefault();

    const objData = {
      user_id: user.pk,
      title,
      address,
      latitude,
      longitude,
    };

    if (!title) return toastErrorMessage("عنوان الزامی میباشد");
    if (!address) return toastErrorMessage("نشانی الزامی میباشد");

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createUserAddressService(objData);
      if (status === 200) {
        handleCloseModal();
        if (getAddresses) getAddresses(user);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <>
      <button className="btn btn-outline-primary" onClick={handleShowModal}>
        <i className="fa fa-map-marker-alt" /> ثبت آدرس جدید
      </button>

      <CustomModal
        show={isShowModal}
        title="افزودن آدرس جدید"
        size="lg"
        onHide={handleCloseModal}
      >
        {step === 1 ? (
          <>
            <Map
              initialViewState={{ ...initialViewState, zoom: 14 }}
              style={{ width: "auto", height: "50vh" }}
              mapboxAccessToken={mapBoxAccessToken}
              mapStyle="mapbox://styles/mapbox/streets-v11"
              onClick={(e) => {
                setLatitude(e.lngLat?.lat);
                setLongitude(e.lngLat?.lng);
              }}
            >
              <GeolocateControl position="bottom-right" />
              <FullscreenControl position="top-right" />
              <NavigationControl position="top-left" />

              <Marker
                longitude={longitude}
                latitude={latitude}
                anchor="bottom"
                draggable
              >
                <MapMarkerIcon />
              </Marker>
            </Map>

            <hr />
            <button
              className="btn btn-primary"
              disabled={!latitude || !longitude}
              onClick={handleChangeStep}
            >
              تایید و ادامه
            </button>
          </>
        ) : (
          <>
            <form autoComplete="off" onSubmit={handleCreateAddress}>
              {/* Title */}
              <div className="mb-3">
                <label className="mb-1">عنوان</label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
              {/* Address */}
              <div className="mb-3">
                <label className="mb-1">نشانی</label>
                <textarea
                  name="address"
                  className="form-control"
                  rows={7}
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>
              <div className="d-flex justify-content-between mt-3">
                <button type="submit" className="btn btn-primary">
                  تایید و ثبت آدرس
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => handleChangeStep("Prev")}
                >
                  بازگشت
                </button>
              </div>
            </form>
          </>
        )}
      </CustomModal>
    </>
  );
};

// Edit address
const EditAddressUser = ({ getAddresses, oldAddress, user }) => {
  const dispatch = useDispatch();

  const [title, setTitle] = useState("");
  const [address, setAddress] = useState("");
  const [longitude, setLongitude] = useState("");
  const [latitude, setLatitude] = useState("");
  const [step, setStep] = useState(1);
  const [isShowModal, setIsShowModal] = useState(false);

  const handleShowModal = () => {
    setIsShowModal(true);

    // Set previous data
    setTitle(oldAddress?.title);
    setAddress(oldAddress?.address);
    setLongitude(oldAddress?.longitude);
    setLatitude(oldAddress?.latitude);
  };
  const handleCloseModal = () => {
    setIsShowModal(false);
    setTitle("");
    setAddress("");
    setLongitude("");
    setLatitude("");
    setStep(1);
  };

  // Handle Change Step Method
  const handleChangeStep = (type = "Next") => {
    if (type === "Prev") {
      setStep(1);
    } else {
      if (!longitude || !latitude)
        return toastErrorMessage("لطفا آدرس کاربر را به درستی انتخاب کنید");

      setStep(2);
    }
  };

  // Handle Edit Address Method
  const handleEditAddress = async (event) => {
    event.preventDefault();

    const objData = {
      user_id: user.pk,
      id: oldAddress.id,
      title,
      address,
      latitude,
      longitude,
    };

    if (!title) return toastErrorMessage("عنوان الزامی میباشد");
    if (!address) return toastErrorMessage("نشانی الزامی میباشد");

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editUserAddressService(objData);
      if (status === 200) {
        handleCloseModal();
        getAddresses(user);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <>
      <i
        className="fa fa-edit text-primary"
        onClick={handleShowModal}
        type="button"
      />

      <CustomModal
        show={isShowModal}
        title="ویرایش آدرس جدید"
        size="lg"
        onHide={handleCloseModal}
      >
        {step === 1 ? (
          <>
            <Map
              initialViewState={{ ...initialViewState, zoom: 14 }}
              style={{ width: "auto", height: "50vh" }}
              mapboxAccessToken={mapBoxAccessToken}
              mapStyle="mapbox://styles/mapbox/streets-v11"
              onClick={(e) => {
                setLatitude(e.lngLat?.lat);
                setLongitude(e.lngLat?.lng);
              }}
            >
              <GeolocateControl position="bottom-right" />
              <FullscreenControl position="top-right" />
              <NavigationControl position="top-left" />

              <Marker
                longitude={longitude}
                latitude={latitude}
                anchor="bottom"
                draggable
              >
                <MapMarkerIcon />
              </Marker>
            </Map>

            <hr />
            <button
              className="btn btn-primary"
              disabled={!latitude || !longitude}
              onClick={handleChangeStep}
            >
              تایید و ادامه
            </button>
          </>
        ) : (
          <>
            <form autoComplete="off" onSubmit={handleEditAddress}>
              {/* Title */}
              <div className="mb-3">
                <label className="mb-1">عنوان</label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
              {/* Address */}
              <div className="mb-3">
                <label className="mb-1">نشانی</label>
                <textarea
                  name="address"
                  className="form-control"
                  rows={7}
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>
              <div className="d-flex justify-content-between mt-3">
                <button type="submit" className="btn btn-primary">
                  تایید و ویرایش آدرس
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => handleChangeStep("Prev")}
                >
                  بازگشت
                </button>
              </div>
            </form>
          </>
        )}
      </CustomModal>
    </>
  );
};
